import {
    Directions,
    EquipmentTypes,
    GeoTypes,
    McQuery,
    TimeFrames,
} from './mc-gauge.models';

export const emptyMcQuery: McQuery = {
    id: '',
    type: 'area',
    direction: Directions.OutBound,
    geoType: GeoTypes.Market,
    geoCode: '',
    equipmentType: EquipmentTypes.Van,
    timeframe: TimeFrames.Current,
    displayName: '',
    date: '',
};
